import { CSSProperties } from 'react'

export const sideBarWidth = 309

export const s = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 48,
  } as CSSProperties,
  button: {
    marginLeft: 'auto',
  },
}
